import {APP_INITIALIZER, NgModule} from '@angular/core';
import {ObtenerConfiguracionMsalService} from '../../services/obtener-configuracion-msal.service';
import {InteractionType, LogLevel, PublicClientApplication} from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {CustomInterceptorInterceptor} from '../../../../infrastructure/interceptor/custom-interceptor.interceptor';
import {OauthInterceptorProvider} from '../../../../infrastructure/interceptor/oauth.interceptor';


let config: any;

export function inicializarConfiguracionMsalFactory(obtenerConfiguracionMsalService: ObtenerConfiguracionMsalService): any {
  const promise = obtenerConfiguracionMsalService.__invoke().then((configuracion) => {
  });
  return () => promise;
}

export function loggerCallback(logLevel: LogLevel, message: string) {
  //console.info(message);
}

export function MSALInstanceFactory(obtenerConfiguracionMsalService: ObtenerConfiguracionMsalService): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: obtenerConfiguracionMsalService.configuracionMSAL.msal.clientId,
      authority: obtenerConfiguracionMsalService.configuracionMSAL.msal.authority,
      redirectUri: obtenerConfiguracionMsalService.configuracionMSAL.msal.redirectUri,
      postLogoutRedirectUri: obtenerConfiguracionMsalService.configuracionMSAL.msal.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage'
    },
    system: {
      tokenRenewalOffsetSeconds: 600,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: true
      }
    }
  });
}

export function MSALInterceptorConfigFactory(obtenerConfiguracionMsalService: ObtenerConfiguracionMsalService): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>(obtenerConfiguracionMsalService.obtenerValor('interceptor'));
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    // Los mapas que sirven los backends de los clientes usan entradas relativas
    // por segmento (p. ej. '/shared') que deben casar '/api/shared/...'. El matching
    // estricto/anclado por defecto de msal-angular >= 5 NO las casa y las peticiones
    // salen sin token (401). strictMatching:false restaura la semántica por substring
    // de msal-angular 3 (idéntica al matchPattern legacy), que es con la que están
    // definidas todas las configuraciones de interceptor en producción.
    strictMatching: false,
  }
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {} as MsalGuardConfiguration;
}

@NgModule({
  declarations: [],
  imports: [MsalModule]
})
export class ConfiguracionMsalModule {
  static forRoot() {
    return {
      ngModule: ConfiguracionMsalModule,
      providers: [
        ObtenerConfiguracionMsalService,
        {
          provide: APP_INITIALIZER,
          useFactory: inicializarConfiguracionMsalFactory,
          deps: [ObtenerConfiguracionMsalService],
          multi: true
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory,
          deps: [ObtenerConfiguracionMsalService]
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory,
          deps: []
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory,
          deps: [ObtenerConfiguracionMsalService]
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        [
          {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomInterceptorInterceptor,
            multi: true
          },
          OauthInterceptorProvider
        ]
      ]
    }
  }
}
